import React, { FC, useState } from "react";
import ColorPicker from "@mindmemobile/mm-color-picker";
import styled from "styled-components";
import { useColorPicker } from "@mindmemobile/mm-color-picker";
import useOutsideClick from "../hooks/useOutsideClick";
import { parseRGBA, parseRGBAToString, UtilityMethods } from "../utils";
import { IColor } from "../interfaces";

//hide graident option
const ColorPickerWrapper = styled.div`
  div:nth-child(2) div:nth-child(1) div:nth-child(1) div:nth-child(2) {
    display: none !important;
  }
`;

type IProps = {
  color?: IColor | undefined | null;
  onChange: (color: IColor) => void;
  panelText?: "";
  className?: string;
  hideGardient?: boolean;
  onHide: () => void;
};

export const SystemColors = [
  "transparent",
  "rgba(255,255,255,1)", //    '#FFFFFF',
  "rgba(229,229,229,1)", //    '#E5E5E5',
  "rgba(204,204,204,1)", //#CCCCCC
  "rgba(178,178,178,1)", //'#B2B2B2',
  "rgba(153,153,153,1)", //'#999999',
  "rgba(102,102,102,1)", //'#666666',
  "rgba(51,51,51,1)", //'#333333',
  "rgba(0,0,0,1)", //'#000000',
  "rgba(140,59,139,1)", //#8C3B8B
  "rgba(238,84,133,1)", // '#EE5485',
  "rgba(218,10,50,1)", //  '#DA0A32',
  "rgba(253,135,0,1)", //'#FD8700',
  "rgba(255,194,0,1)", //#FFC200
  "rgba(103,185,48,1)", //#67B930
  "rgba(0,153,124,1)", //#00997C
  "rgba(0,168,226,1)", // '#00A8E2'
  "rgba(0,126,191,1)", // '#007EBF',
];

const ColorPickerComponent: FC<IProps> = (props: IProps) => {
  const colorValue = parseColorValue();
  const [state, setState] = useState(colorValue);
  const { getGradientObject, valueToHex } = useColorPicker(state);

  const onChangeColor = (value: any) => {
    //this change fix the issue of color change not working after selection of transparent color
    if (state === "transparent" && value != state) {
      const opacity = value.split(",")[3];
      value = value.replace(opacity, opacity.replace("0", "100"));
    }
    setState(value);
    const isGradient = getGradientObject()?.isGradient === true;
    let color = {
      hex: valueToHex(),
      isGradient: isGradient,
      gradient: isGradient ? value : "",
      rgbValue: isGradient ? null : parseRGBA(value),
      rgba: isGradient ? "" : value,
    } as IColor;

    if (!isGradient) {
      //THIS IS BECAUSE WE HAVE ISSUE IN HEX COLOR NOT MATCHING WITH RGB VALUE SO CREATING COLOR OBJECT AGAIN
      color = UtilityMethods.createColor(color.rgbValue!);
    }

    props.onChange(color);
  };

  function parseColorValue(): string {
    const { color } = props;
    if (!color) return "";

    const rgba = parseRGBAToString(color.rgbValue);
    //return { hex: color.hexValue, rgb: rgba, gradient: color.gradient }
    return color.gradient || rgba;
  }

  function onHideColorPicker() {
    props.onHide();
  }

  const handleMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleTouchStart = (event: React.TouchEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const ref = useOutsideClick(onHideColorPicker);
  return (
    <div
      ref={ref}
      style={{
        border: "0px solid rgba(0, 0, 0, 0.25)",
        boxShadow: "rgba(0, 0, 0, 0.25) 0px 1px 4px",
        borderRadius: " 4px",
        width: "314px",
        backgroundColor: "white",
        padding: "10px",
        zIndex: 999,
      }}
      className={`ColorPicker-picker ${props.className}`}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    >
      <ColorPickerWrapper>
        <ColorPicker
          presets={SystemColors}
          value={state}
          onChange={(color: any) => onChangeColor(color)}
          className="picker"
        />
      </ColorPickerWrapper>
    </div>
  );
};

export default ColorPickerComponent;
